// ─────────────────────────────────────────────────────────────────────────────
// KLOTHIQ — SaleCartSummary Component (FEAT-SALE-ITEMS-001)
// ─────────────────────────────────────────────────────────────────────────────
// Pinned reactive cart financial summary for sale creation and editing.
// ─────────────────────────────────────────────────────────────────────────────

export interface SaleCartSummaryProps {
  subtotal: number;
  discount: number;
  deliveryCharge: number;
  total: number;
}

function formatInr(amount: number): string {
  return `₹${amount.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export default function SaleCartSummary({
  subtotal,
  discount,
  deliveryCharge,
  total,
}: SaleCartSummaryProps) {
  return (
    <div className="obsidian-surface rounded-xl border border-border bg-card p-4 shadow-sm">
      <div className="space-y-2 text-sm">
        {/* Subtotal */}
        <div className="flex items-center justify-between text-muted-foreground">
          <span>Subtotal</span>
          <span className="font-medium text-foreground">{formatInr(subtotal)}</span>
        </div>

        {/* Item Discounts */}
        {discount > 0 && (
          <div className="flex items-center justify-between text-emerald-600 dark:text-emerald-400">
            <span>Item Discounts</span>
            <span className="font-medium">-{formatInr(discount)}</span>
          </div>
        )}

        {/* Delivery Charge */}
        {deliveryCharge > 0 && (
          <div className="flex items-center justify-between text-muted-foreground">
            <span>Delivery Charge</span>
            <span className="font-medium text-foreground">+{formatInr(deliveryCharge)}</span>
          </div>
        )}

        {/* Divider */}
        <div className="border-t border-border pt-2">
          <div className="flex items-baseline justify-between">
            <div>
              <span className="text-base font-bold text-foreground">Total Payable</span>
              <p className="text-[11px] text-muted-foreground">Includes all items and delivery</p>
            </div>
            <span className="text-lg font-extrabold text-primary">
              {formatInr(total)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
